import { Controller } from '../utils/controller';
import getPerlgemCSRFToken from '../utils/perlgem_csrf';

export default class extends Controller {
  static targets = ['firstName', 'firstNameError', 'password', 'submitButton'];

  //TARGETS
  declare firstNameTarget: HTMLInputElement;
  declare firstNameErrorTarget: HTMLElement;
  declare passwordTarget: HTMLInputElement;
  declare submitButtonTarget: HTMLButtonElement;

  declare readonly hasFirstNameTarget: boolean;
  declare readonly hasFirstNameErrorTarget: boolean;
  declare readonly hasPasswordTarget: boolean;
  declare readonly hasSubmitButtonTarget: boolean;

  // LOCAL STATE
  private hideClass: string;
  private cursorNotAllowedClass: string;

  initialize() {
    this.hideClass = 'hidden';
    this.cursorNotAllowedClass = 'cursor-not-allowed';
  }

  validateFirstName(firstName: string) {
    return firstName.length !== 0;
  }

  focus(isFirstNameValid: boolean, isPasswordValid: boolean) {
    if (!isFirstNameValid) {
      this.firstNameTarget.focus();
      return;
    }

    if (!isPasswordValid) {
      this.passwordTarget.focus();
      return;
    }
  }

  disableButton(hasTarget: boolean, target: HTMLButtonElement) {
    if (hasTarget) {
      target.classList.add(this.cursorNotAllowedClass);
      target.setAttribute('disabled', '');
    }
  }

  enableButton(hasTarget: boolean, target: HTMLButtonElement) {
    if (hasTarget) {
      target.classList.remove(this.cursorNotAllowedClass);
      target.removeAttribute('disabled');
    }
  }

  validate() {
    this.hasFirstNameErrorTarget && this.firstNameErrorTarget.classList.add(this.hideClass);
    const isFirstNameValid = this.validateFirstName(this.firstNameTarget.value);
    const isPasswordValid = this.passwordTarget.getAttribute('is-valid') === 'true';

    if (!isFirstNameValid) {
      this.hasFirstNameErrorTarget && this.firstNameErrorTarget.classList.remove(this.hideClass);
    }

    this.focus(isFirstNameValid, isPasswordValid);

    return isFirstNameValid && isPasswordValid;
  }

  async signUp(event: Event) {
    try {
      event.preventDefault();

      if (!this.validate()) {
        return;
      }

      this.disableButton(this.hasSubmitButtonTarget, this.submitButtonTarget);

      const token = (await getPerlgemCSRFToken()) || '';
      const formData = new URLSearchParams();

      formData.append('_SUBMIT', 'loyalty_registration');
      formData.append('FIRST_NAME', this.firstNameTarget.value);
      formData.append('PASSWORD', this.passwordTarget.value);
      formData.append('_TOKEN', token);

      const response = await fetch('/account/signin.tmpl', {
        method: 'POST',
        body: formData,
        mode: 'cors'
      });

      if (response.ok && response.redirected) {
        window.location.href = response.url;
        return;
      }
    } catch {
      const serviceError = document.querySelector<HTMLElement>('[data-behavior="serviceError"]');
      const accountCreate = document.querySelector<HTMLElement>(
        '[data-loyalty-nav-target="accountCreate"]'
      );
      const accountCreateWithPromo = document.querySelector<HTMLElement>(
        '[data-loyalty-nav-target="accountCreateWithPromo"]'
      );

      if (serviceError) {
        accountCreateWithPromo?.classList.add(this.hideClass);
        accountCreate?.classList.add(this.hideClass);
        serviceError.classList.remove(this.hideClass);
      }
    } finally {
      this.enableButton(this.hasSubmitButtonTarget, this.submitButtonTarget);
    }
  }
}
